import Router from 'vue-router'
import { defaultRouterOptions, defaultRoutes } from '@i22/frontend-cms-utils/router'

import Default from 'beisheim/pages/default'
import Splash from 'beisheim/pages/splash'

export function createRouter () {
  return new Router({
    ...defaultRouterOptions,
    routes: [
      defaultRoutes.assets,
      {
        path: '/:country/:language',
        component: Default
      },
      {
        path: '/:country/:language/*',
        component: Default
      },
      {
        path: '/:country',
        component: Splash
      },
      {
        path: '*',
        component: Splash
      }
    ],
  })
}
